import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import React from "react";
import { Flex, StatusDot, Popover, Small } from "orcs-design-system";
import { withRouter } from "react-router";
import { teamDetailsPath } from "../../util/routing";

const htmlMarkup = (html) => {
  return {
    __html: DOMPurify.sanitize(html),
  };
};

const badgeDetailsMap = {
  TRUE: {
    colour: "success",
    text: "MET",
  },
  FALSE: {
    colour: "danger",
    text: "NOT MET",
  },
  INSUFFICIENT_DATA: {
    colour: "warning",
    text: "N/A",
  },
};

const principleVariantMap = {
  TRUE: "success",
  FALSE: "danger",
  INSUFFICIENT_DATA: "warning",
};

const statusLabel = (principle) =>
  principle.signal?.text ||
  badgeDetailsMap[principle.met]?.text ||
  principle.met;

const dotVariant = (principle) =>
  principle.signal?.color ||
  principleVariantMap[principle.met] ||
  principleVariantMap.INSUFFICIENT_DATA;

const principleStatusText = (principle, showRuleDetail = false) => {
  return (
    <>
      <div dangerouslySetInnerHTML={htmlMarkup(principle?.title)} />
      <Small fontWeight="bold">STATUS : {statusLabel(principle)}</Small>
      {showRuleDetail && principle.met === "FALSE" && principle.ruleDetail && (
        <>
          <br />
          <Small fontWeight="bold">
            REASON :{" "}
            <span dangerouslySetInnerHTML={htmlMarkup(principle.ruleDetail)} />
          </Small>
        </>
      )}
    </>
  );
};

const PrincipleStatus = ({ team, history, textDirection, marginTop }) => {
  const statusDots = [];
  if (team && team.principles) {
    team.principles.forEach((principle) => {
      statusDots.push(
        <Popover
          key={team.id + principle.title}
          direction={textDirection || "bottomRight"}
          text={principleStatusText(principle)}
          textAlign="left"
          width="300px"
        >
          <StatusDot
            variant={dotVariant(principle)}
            onClick={() => history.push(teamDetailsPath(team, "principles"))}
          />
        </Popover>
      );
    });
  }

  return statusDots.length > 0 ? (
    <Flex alignItems="center" mt={marginTop} gap="xs">
      {statusDots}
    </Flex>
  ) : null;
};

// TODO: Fix team def, object
PrincipleStatus.propTypes = {
  team: PropTypes.shape({
    id: PropTypes.string,
    principles: PropTypes.array,
  }),
  history: PropTypes.object,
  textDirection: PropTypes.string,
  marginTop: PropTypes.string,
};

export { principleStatusText, statusLabel, dotVariant };

export default withRouter(PrincipleStatus);
